import { motion } from 'framer-motion';
import { useLandingImages } from '../landing/LandingImageContext';

function Reveal({ children, className = '' }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y: 25 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.2 }}
      transition={{ duration: 0.7 }}
    >
      {children}
    </motion.div>
  );
}

export function Story() {
  const images = useLandingImages();

  return (
    <section className="editorial story-section" id="story">
      <div className="editorial-image">
        <img
          src={images.story}
          alt="Woman presenting a dark ZEVI saree"
          loading="lazy"
        />
      </div>
      <Reveal className="editorial-copy">
        <span className="eyebrow">Our Story</span>
        <h2>The Art of<br />The Drape</h2>
        <p>
          ZEVI celebrates timeless elegance through carefully selected sarees
          designed for women who appreciate sophistication, beauty, and
          effortless style.
        </p>
        <a className="text-button" href="#about">
          Discover our story <span>→</span>
        </a>
      </Reveal>
    </section>
  );
}

export function ThreadStory() {
  const images = useLandingImages();

  return (
    <section className="thread-section">
      <img
        src={images.thread}
        alt="Woman wearing a richly detailed burgundy saree"
        loading="lazy"
      />
      <div className="thread-overlay" />
      <Reveal className="thread-copy">
        <h2>Every Thread<br />Tells A Story</h2>
        <p>
          From intricate details to graceful silhouettes, discover sarees
          created to make every occasion memorable.
        </p>
        <a className="outline-button" href="#collection">
          View the collection
        </a>
      </Reveal>
    </section>
  );
}

export function About() {
  const images = useLandingImages();

  return (
    <section className="editorial about-section" id="about">
      <Reveal className="editorial-copy">
        <span className="eyebrow">Our Philosophy</span>
        <h2>About ZEVI</h2>
        <p>
          ZEVI is a celebration of timeless elegance. Our sarees are all about
          quality and detail. Our collections are thoughtfully curated for
          women who believe true luxury lies in the details.
        </p>
        <a className="outline-button" href="#contact">Learn more</a>
      </Reveal>
      <div className="editorial-image">
        <img
          src={images.about}
          alt="ZEVI saree editorial portrait"
          loading="lazy"
        />
      </div>
    </section>
  );
}